(function () {

    "use strict";

    function fileitemService($q, $http, Upload, URL, $resource) {

        var self = this;

        self.onCreateFileItemEvent = function (files, errFiles, metadatas, idFileContainer, isRecordContainer, idVersion) {
            var defered = $q.defer();
            var promise = defered.promise;

            self.files = [];
            if (idVersion) {
                self.uploadFileItemVersion(files, idVersion, metadatas)
                    .then(function (data) {//Ok
                        console.log('Success: ' + data);
                        defered.resolve(data);
                    }, function (reason) {//Fail
                        console.log('Failed: ' + reason);
                        defered.reject(reason);
                    });
            } else {
                uploadFileItem(files, idFileContainer, metadatas, isRecordContainer).then(
                    function (data) {
                        defered.resolve(data.data.id);
                    },
                    function (error) {
                        defered.reject(error);
                    });
            }
            return promise;
        };
        /*
      * Subida de documents al servidor. 
      * @param {type} files Ficheros seleccionados/arrastrados
      * @param {type} idFileContainer Identificador del filecontainer en la que se incluir�n los ficheros
      * @param {type} metadatas List de los metadatas con los que se create� el fileitem
      */
        function uploadFileItem(files, idFileContainer, metadatas, isRecordContainer) {
            console.log('uploadFileItem:idFileContainer=' + idFileContainer);

            console.log('Comenzar subida fichero....');

            var deferred = $q.defer();

            self.uploadFileItemServer(files, idFileContainer, metadatas, isRecordContainer)
                .then(function (data) {//Ok
                    console.log('Success: ' + data);
                    deferred.resolve(data);
                }, function (reason) {//Fail
                    console.log('Failed: ' + reason);
                    deferred.reject(reason);
                });


            return deferred.promise;
        }

        /**
        * Sube un document a la folder indicada en idFolder o a la folder actual si no se especifica
        * Funci�n para ser utilizda con la directiva ngf-drop de ng-file-upload
        * @param {type} files Document a subir
        * @param {type} idFileContainer Identificador del filecontainer al que se subiran los ficheros
        * @param {type} metadatas Metadatas asociados al fileitem creado
        * @param {type} isRecordContainer Indicates whether the FileContainer is a RecordContainer
        * @returns {type} la promesa de la operacion
        */
        self.uploadFileItemServer = function (files, idFileContainer, metadatas, isRecordContainer) {

            var deferred = $q.defer();
            var file = {};
            Upload.upload({
                url: URL.URL + '/api/fileitems/' + idFileContainer + '/' + isRecordContainer,
                data: {
                    file: files,
                    metadatas: JSON.stringify(metadatas)
                }
            }).then(function (data) {
                file.uploadOk = true;
                deferred.resolve(data);
            }, function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        };

        self.uploadFileItemVersion = function (files, idFileItem, metadatas) {

            var deferred = $q.defer();
            var file = {};
            Upload.upload({
                url: URL.URL + '/api/fileitems/version/' + idFileItem,
                data: {
                    file: files,
                    metadatas: JSON.stringify(metadatas)
                }
            }).then(function (data) {
                file.uploadOk = true;
                deferred.resolve(data);
            }, function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        };
        self.delete = function (idFileContainer, idFileItem) {
            return $q(function (resolve, reject) {
                $http.delete(URL.URL + "/api/fileitems/" + idFileContainer + "/" + idFileItem)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        console.dir(error);
                        reject();
                    });
            });
        };
        self.downloadDoc = $resource(URL.URL + '/api/download/fileitems/:id', { id: '@_id' }, {
            search: {
                method: 'POST'
            }
        });

        self.sePuedeAbrirConOffice = function (idfilecontainer, idfileitem, action) {
            var parametros = idfilecontainer + '/' + idfileitem + '/' + action;
            var url = URL.URL + '/api/office/canview/documentary/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject();
                    });
            });
        };

        self.abrirConOffice = function (idfilecontainer, idfileitem, token, action, canprint) {
            var parametros = idfilecontainer + '/' + idfileitem + '/' + token + '/' + action + '?canprint=' + canprint;
            var url = URL.URL + '/api/office/link/documentary/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                        reject();
                    });
            });
        };

        self.getUrlAppViewer = function () {
            var url = URL.URL + '/api/appconfig/getconfiguration';
            return $q(function (resolve, reject) {
                $http.get(url, { cache: true }).then(function (response) {
                    resolve(response.data);
                }).catch(function (error) {
                    console.log(error);
                    reject();
                });
            });
        };

    }

    fileitemService.$inject = ["$q", "$http", "Upload", "URL", "$resource"];

    angular.module("solpheo").service("solpheo.fileitemService", fileitemService);

})();
